import type { WithTestId } from '@ab-core/testing';
import Text, { FontTypes } from '@ab-core/text';
import type { FC } from 'react';
import React from 'react';
import styled from 'styled-components';

export type InfoItemType = WithTestId & {
    label: string;
    content: string | React.ReactNode;
    color?: string;
    id?: string;
};

export const TextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom: 0.75rem;
`;

export const InfoItem: FC<InfoItemType> = ({ label, content, color, ...rest }) => (
    <TextWrapper {...rest}>
        <Text color="gray70" type={FontTypes.Subtitle} content={label} />
        {typeof content === 'string' ? (
            <Text color={color} className="text-word-keep-all">
                {content}
            </Text>
        ) : (
            <>{content}</>
        )}
    </TextWrapper>
);
